import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {persistor, store} from '@app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import './css/tabs.css';
import 'react-tree-graph/dist/style.css'
import moment from 'moment';
import 'moment/locale/it' // without this line it didn't work
import * as Axios from "@utilities/config.Axios";
import "react-datepicker/dist/react-datepicker.css";
import {ToastContainer} from "react-toastify";
import AppHR from "./AppHR";
import AppLavRetribuzioni from "./AppLavRetribuzioni";
import AppPVARetribuzioni from "./AppPVARetribuzioni";
import AppDashboardWF from "./AppDashboardWF";
import {fetchConfig, PlatformType} from "@commons/utils/fetchBaseFPNetQuery";
import ValidaEmail from "./pages/ValidaEmail";
import {Settings} from 'luxon';
import {PersistGate} from 'redux-persist/integration/react';
import AppPianificazione from "./AppPianificazione";
import {setUseWhatChange} from "@simbathesailor/use-what-changed";
import {LoadingSpinner} from "@components/comboBox/ComboBox";

const container = document.getElementById('root')!;
const root = createRoot(container);

// Configuro Axios
Axios.injectStore(store);
fetchConfig.platformType = 'web';
fetchConfig.isMobile = false;

// Per simulare l'app mobile
/*
fetchConfig.platformType = 'ios';
fetchConfig.isMobile = true;
systemInfo.appName='fpnet-app'
*/

//fetchConfig.useDefaultPropertyNamingStrategy = true;
Axios.config(fetchConfig);

// Configuro moment (imposto italiano)
moment.locale('it');
Settings.defaultLocale = 'it';

//https://github.com/simbathesailor/use-what-changed?tab=readme-ov-file
setUseWhatChange(process.env.NODE_ENV === 'development');

// vedi https://stackoverflow.com/questions/28295870/how-to-pass-parameters-through-iframe-from-parent-html
function getParamValue(paramName: string) {
    var url = window.location.search.substring(1); //get rid of "?" in querystring
    var qArray = url.split('&'); //get key-value pairs
    for (var i = 0; i < qArray.length; i++) {
        var pArr = qArray[i].split('='); //split key and value
        if (pArr[0] === paramName)
            return pArr[1]; //return value
    }
}

const getApp = () => {
    switch (getParamValue('app')) {
        case 'DashboardWF':
            return AppDashboardWF;
        case 'PVARetribuzioni':
            return AppPVARetribuzioni;
        case 'LavRetribuzione':
            return AppLavRetribuzioni;
        case 'Pianificazione':
            return AppPianificazione;

        default:
            return AppHR;
    }
};

const auth_token = getParamValue('auth_token');
const validateEmail = getParamValue('validate_email');
const device = getParamValue('device') as PlatformType | undefined;
root.render(
    /*<React.StrictMode>*/
    <Provider store={store}>
        <PersistGate loading={<LoadingSpinner/>} persistor={persistor}>
            {!validateEmail && <App AppXXX={getApp()} auxToken={auth_token}/>}
            {validateEmail && <ValidaEmail auxToken={auth_token!} device={device || 'web'}/>}
            <ToastContainer
                position="bottom-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"/>
        </PersistGate>
    </Provider>
    /*</React.StrictMode>*/
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();


// todo DA VEDERE
// https://floating-ui.com/
// https://headlessui-float.vercel.app/
// https://www.npmjs.com/package/@headlessui-float/react